// App constants

export const SET_SORT_ORDER = 'SET_SORT_ORDER';
export const SET_CONTENTMODAL = 'SET_CONTENTMODAL';
export const SET_AUTHENTICATED = 'SET_AUTHENTICATED';
export const SET_JWT = 'SET_JWT';
export const SET_ERROR = 'SET_ERROR';
export const CLEAR_ERROR = 'CLEAR_ERROR';
export const SET_LOADING = 'SET_LOADING';
export const CLEAR_LOADING = 'CLEAR_LOADING';
